import HttpService from "@/services/HttpService";
const httpService = new HttpService();

export default class PlaceService {
  getPlaceById: any = async (ownerId: string, placeId: string) => {
    return await httpService
      .fetch("GET", `api/place/web/owner/${ownerId}/place/${placeId}`, {})
      .then((place) => {
        console.log("get user places from back", place);
        return place;
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  /**
   *get places from an owner (given id)
   * @param id
   */
  getPlacesByOwnerId: any = async (id: string) => {
    return await httpService
      .fetch("GET", `api/place/web/ownerplaces/${id}`, {})
      .then((places) => {
        console.log("get user places from back", places);
        return places;
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  /**
   * get the payment object from the placeId
   * @param ownerId
   * @param placeId
   */
  getPaymentFromPlace: any = async (ownerId: string, placeId: string) => {
    console.log("get payment of a place", placeId);

    const serverResponse = await httpService.fetch(
      "GET",
      `api/payment/place/${placeId}/owner/${ownerId}`,
      {}
    );

    console.log("yofezoifjeirgreji", serverResponse);

    if (serverResponse.exists) {
      return serverResponse.payment;
    } else {
      return {};
    }
  };

  /**
   * get a stripe subscription from stripe API from a subscription id
   * @param ownerId
   * @param subId
   */
  getPlaceStripeSubscriptionFromSubId: any = async (
    ownerId: string,
    subId: string
  ) => {
    // api to create, see : https://stripe.com/docs/api/subscriptions/retrieve?lang=node
    if (ownerId == undefined || subId == undefined) {
      return {};
    }
    console.log("get subscription for id", subId);
    const serverResponse = await httpService.fetch(
      "GET",
      `api/payment/subscription/${subId}/owner/${ownerId}`,
      {}
    );

    if (serverResponse.success) {
      return serverResponse.subscription;
    } else {
      return {};
    }
  };

  /**
   * get an invoice of a given subscription
   * @param ownerId
   * @param subscriptionId
   * @returns
   * "https://invoice.stripe.com/i/acct_1FGi07EZx37FkV8x/invst_KGVycWoeyIzPy97ZGmurz7thLt6Ke2q"
   * "https://pay.stripe.com/invoice/acct_1FGi07EZx37FkV8x/invst_KGVycWoeyIzPy97ZGmurz7thLt6Ke2q/pdf"
   */
  getInvoiceByPlaceSubscription: any = async (
    ownerId: string,
    subscriptionId: string
  ) => {
    console.log("get invoices of a sub", subscriptionId);

    const serverResponse = await httpService.fetch(
      "GET",
      `api/payment/invoice/subscription/${subscriptionId}/owner/${ownerId}`,
      {}
    );

    if (serverResponse.success) {
      return serverResponse.invoice;
    } else {
      return {};
    }
  };

  /**
   * Get an invoice by its id
   * @param ownerId
   * @param invoiceId
   */
  getInvoiceById: any = async (ownerId: string, invoiceId: string) => {
    console.log("get invoice of id", invoiceId);

    const serverResponse = await httpService.fetch(
      "GET",
      `api/payment/invoice/${invoiceId}/owner/${ownerId}`,
      {}
    );

    if (serverResponse.success) {
      return serverResponse.invoice;
    } else {
      return {};
    }
  };

  /**
   * Add a place with the adding form
   * @param place
   */
  addPlaceByOwner = async (place: any, ownerId: string) => {
    // IF ITS ADDED BUT NOT BY OWNER, LINK PLACE TO OWNER
    place.coordinates = place.geometry.location;
    delete place.geometry;
    delete place.formatted_address;
    delete place.types;
    console.log("add place", place);
    const serverResponse = await httpService.fetch(
      "POST",
      `api/place/web/addByOwner`,
      { place }
    );
    console.log("from service", serverResponse);
    if (serverResponse.success) {
      return serverResponse.addedPlace;
    } else {
      // success = false
      if (
        serverResponse.error == "PLACE_ALREADY_EXISTS" &&
        serverResponse.fullAnswer.place.owner_id == null
      ) {
        // place exists but added by user => link to connected owner
        const linkToPlaceResponse = await httpService.fetch(
          "POST",
          `api/place/web/linkPlaceToOwner`,
          { ownerId, placeId: serverResponse.fullAnswer.place.uid }
        );

        console.log("linkToPlaceResponse", linkToPlaceResponse);
        return { success: true, ownerId: linkToPlaceResponse.owner_id };
        // link ot owner
      } else {
        return { err: serverResponse.error, place: serverResponse.addedPlace };
      }
    }
  };
}
